import React, { useState, useEffect } from "react";
import { List, Row, Col, Table } from "antd";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var PrescriptionList = function PrescriptionList(_ref) {
  var data = _ref.data,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? 0 : _ref$origin;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        textAlign: "center",
        marginBottom: "30px"
      }
    }), origin == 0 && /*#__PURE__*/_jsx(List, {
      dataSource: data,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          children: /*#__PURE__*/_jsx(List.Item.Meta, {
            title: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("b", {
                style: {
                  display: "inline-block",
                  width: "50%"
                },
                children: [item.position.toString(), " / ", item.label]
              }), " ................................................................... Qte: ", item.quantity]
            }),
            description: /*#__PURE__*/_jsx("span", {
              style: {
                color: '#E96479'
              },
              children: item.comment
            })
          })
        });
      }
    }), origin == 1 && /*#__PURE__*/_jsxs(Table, {
      bordered: false,
      children: [/*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: "test"
        }), /*#__PURE__*/_jsx("td", {
          children: "test"
        }), /*#__PURE__*/_jsx("td", {
          children: "test"
        })]
      }), data.map(function (d) {
        /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsxs("td", {
            children: [/*#__PURE__*/_jsxs("b", {
              children: [d.position.toString(), " / ", d.label, " "]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              style: {
                color: '#E96479'
              },
              children: d.comment
            })]
          }), /*#__PURE__*/_jsx("td", {
            style: {
              fontSize: "1dp"
            },
            children: "........................................................................"
          }), /*#__PURE__*/_jsxs("td", {
            children: ["Qte: ", d.quantity]
          })]
        }, d.id);
      })]
    })]
  });
};
export default PrescriptionList;